import type { Address } from 'src/app/types';
import { GOOGLE_MAPS_ID_FOR_CAPSULE, LOCALIZED_CONTACT_INFO } from 'src/consts';

const { CAPSULE_ADDRESS_LINE_TWO, CAPSULE_ADDRESS_LINE_THREE } = LOCALIZED_CONTACT_INFO;

export const getCapsuleAddressMapUrl = (city: string) => {
  const encodedAddress = encodeURI(`${CAPSULE_ADDRESS_LINE_TWO[city]}, ${CAPSULE_ADDRESS_LINE_THREE[city]}`);

  if (navigator.platform.indexOf('iPhone') !== -1 || navigator.platform.indexOf('iPad') !== -1) {
    return `http://maps.apple.com/?q=Capsule&address=${encodedAddress}`;
  }

  return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}&query_place_id=${GOOGLE_MAPS_ID_FOR_CAPSULE[city]}`;
};

export const getAddressMapUrl = (name: string, address: string) => {
  if (navigator.platform.indexOf('iPhone') !== -1 || navigator.platform.indexOf('iPad') !== -1) {
    return `http://maps.apple.com/?q=${name ? encodeURI(name) : ''}&address=${encodeURI(address)}`;
  }

  return `https://www.google.com/maps/search/?api=1&query=${encodeURI(
    `${name ?? ''}${name && address ? ', ' : ''}${address ?? ''}`
  )}`;
};

export const getFormattedAddress = (baseAddress?: Address) => {
  if (!baseAddress) return null;
  return `${baseAddress.address}, ${baseAddress.addressTwo ? `${baseAddress.addressTwo}, ` : ''}${baseAddress.city}, ${
    baseAddress.state
  } ${baseAddress.zipCode}`;
};
